// extracted by mini-css-extract-plugin
export default {"bannerTitle":"FooterBanner_bannerTitle__NRPqB"};